<template>
  <div class="footer scroll-fade">
    <img src="@/assets/home/footer.png" alt="" class="footer-icon" />
    <img src="@/assets/mobile/f.png" alt="" class="mobile-footer-icon" />
    <div class="footer-info">
      <div class="time">
        <img src="@/assets/home/c.png" alt="" class="c-icon" />
        2024
      </div>
      <div class="footer-link">
        <img
          src="@/assets/home/tt.png"
          alt=""
          class="footer-tt-icon"
          @click="goPathUrl('x')"
        />
        <img
          src="@/assets/home/d.png"
          alt=""
          class="footer-d-icon"
          @click="goPathUrl('dis')"
        />
        <img
          src="@/assets/home/ins.png"
          alt=""
          class="footer-ins-icon"
          @click="goPathUrl('ins')"
        />
        <img
          src="@/assets/home/tg.png"
          alt=""
          class="footer-ins-icon margin-left-two"
          @click="goPathUrl('tg')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { xUrlApi, tgUrlApi, insUrlApi, disUrlApi } from "@/api/other";

const goPathUrl = async (type: string) => {
  let api;
  switch (type) {
    case "tg":
      api = tgUrlApi;
      break;
    case "dis":
      api = disUrlApi;
      break;
    case "ins":
      api = insUrlApi;
      break;
    case "x":
      api = xUrlApi;
      break;
  }

  if (api) {
    const res = await api();
    if (res.code === 200 && res.data) {
      window.location.href = res.data;
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  width: 85.9375rem;
  margin: 0 auto;
  margin-top: 26rem;
  padding-bottom: 6.125rem;
  .footer-icon {
    width: 85.9375rem;
    height: 4.5625rem;
    z-index: 1;
  }
  .mobile-footer-icon {
    display: none;
  }
  .footer-info {
    width: 85.9375rem;
    display: flex;
    align-content: center;
    justify-content: space-between;
    z-index: 2;
    margin-top: -1.7rem;
    .time {
      font-size: 1.53rem;
      color: #fffefe;
      display: flex;
      align-items: center;
      font-family: FCH;
      .c-icon {
        margin-right: 0.6875rem;
        width: 2rem;
        height: 2rem;
      }
    }
    .footer-link {
      display: flex;
      align-items: center;
      .footer-tt-icon {
        width: 2rem;
        height: 2rem;
      }
      .footer-d-icon {
        margin: 0 1rem;
        width: 2rem;
        height: 2rem;
      }
      .footer-ins-icon {
        width: 2rem;
        height: 2rem;
      }
      .margin-left-two {
        margin-left: 1rem;
      }
    }
  }
}
@media (max-width: 750px) {
  .footer {
    width: 329px;
    margin: 0 auto;
    margin-top: 104px;
    padding-bottom: 33px;
    .footer-icon {
      width: 85.9375rem;
      height: 4.5625rem;
      z-index: 1;
      display: none;
    }
    .mobile-footer-icon {
      display: block;
      width: 329px;
      height: 17px;
    }
    .footer-info {
      width: 329px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      z-index: 2;
      margin-top: -1px;
      .time {
        font-size: 8px;
        color: #fffefe;
        display: flex;
        align-items: center;
        font-family: FCH;
        .c-icon {
          margin-right: 4px;
          width: 7px;
          height: 7px;
        }
      }
      .footer-link {
        display: flex;
        align-items: center;
        .footer-tt-icon {
          width: 12px;
          height: 12px;
        }
        .footer-d-icon {
          margin: 0 12px;
          width: 12px;
          height: 12px;
        }
        .footer-ins-icon {
          width: 12px;
          height: 12px;
        }
        .margin-left-two {
          margin-left: 12px;
        }
      }
    }
  }
}
</style>
